import React, { useState } from 'react';
import { AdminNavbar } from '../../Components/Navbars';
import { Form } from 'react-bootstrap';
import { DatePicker, RadioChangeEvent } from 'antd';
import { Radio, Button } from 'antd';
import { Input } from 'antd';
import usePortalService from '../../services/PortalService';
import { useNavigate } from 'react-router-dom';
import { RegistrationLinkInfo } from '../../Components/Modals/RegistrationLinkInfo';

const { TextArea } = Input;

export const CreateRegistrationLink = () => {
    const {createRegistrationLink} = usePortalService();
    const navigate = useNavigate();

    const [typeLink, setTypeLink] = useState(1);
    const [date, setDate] = useState<Date | null>(null);
    const [description, setDescription] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [link, setLink] = useState<string>('');

    const onTypeLinkChange = (e: RadioChangeEvent) => {
        setTypeLink(e.target.value);
    };

    const expiredDateHandler = (e: Date | null) => {
        if (e) {
            setDate(e);
        }
    };

    const descriptionChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setDescription(e.target.value)
    }

    const createHandler = async () => {
        if (date) {
            const expiredDate = date.toISOString().split('T')[0];
            const result = await createRegistrationLink({
                type : typeLink,
                expiredDate,
                description
            })

            console.log(result)
            if (result.success) {
                setLink(result.link)
                setIsModalOpen(true);
            }
        }
    }

    const closeModalHandler = () => {
        setIsModalOpen(false);
        navigate('/registrationLinks');
    }

    return (
        <>
            <AdminNavbar />
            <div className="page700" style={{marginBottom:'115px'}}>
                <h1 style={{paddingBottom:'24px'}}> Создание ссылки для регистрации </h1>
                <Form>
                    <div className="form-group">
                        <Form.Label style={{marginBottom:'8px'}}> Тип ссылки: </Form.Label>
                        <div className="group-select-elements" >
                            <Radio.Group onChange={onTypeLinkChange} value={typeLink}>
                                <Radio value={1}> Индивидуальная </Radio>
                                <Radio value={0}> Для события </Radio>
                            </Radio.Group>
                        </div>
                    </div>
                    <div className="form-group">
                        <Form.Label> Дата окончания действия </Form.Label>
                        <DatePicker onChange={expiredDateHandler} value={date}/>
                    </div>
                    <div className="form-group">
                        <Form.Label> Комментарий к ссылке </Form.Label>
                        <TextArea
                            rows={4}
                            value={description}
                            onChange={descriptionChangeHandler}
                        />
                    </div>
                    <Button type="text"> Отмена </Button>
                    <Button type="primary" onClick={createHandler}> Создать </Button>
                </Form>
            </div>
            <RegistrationLinkInfo 
                onClose={closeModalHandler} 
                isOpen={isModalOpen} 
                link={link} 
                description={description}
                headline="Ссылка успешно создана" 
            />
        </>
    )
};